import { useState } from "react";

interface ChatProps {
  onSendMessage: (message: string) => Promise<void>;
  response: string;
  loading: boolean;
}

export default function Chat({ onSendMessage, response, loading }: ChatProps) {
  const [message, setMessage] = useState("");

  const handleSend = async () => {
    if (!message.trim()) return;
    await onSendMessage(message);
    setMessage("");
  };

  return (
    <div
      style={{
        padding: "1.5rem",
        border: "1px solid #ddd",
        borderRadius: "8px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        maxWidth: "800px",
        margin: "0",
      }}
    >
      <div style={{ display: "flex", marginBottom: "1rem" }}>
        <input
          placeholder="Ask a question"
          style={{
            width: "100%",
            padding: "0.75rem",
            borderRadius: "4px",
            border: "1px solid #ccc",
            fontSize: "16px",
            marginRight: "0.5rem",
          }}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleSend()}
        />
        <button
          disabled={loading}
          style={{
            padding: "0.75rem 1.5rem",
            backgroundColor: loading ? "#cccccc" : "#4a90e2",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: loading ? "default" : "pointer",
            fontWeight: "bold",
            transition: "background-color 0.2s",
          }}
          onClick={handleSend}
        >
          {loading ? "Loading..." : "Send"}
        </button>
      </div>

      {response && (
        <div
          style={{
            marginTop: "1.5rem",
            padding: "1rem",
            backgroundColor: "#f8f9fa",
            borderRadius: "4px",
            border: "1px solid #e9ecef",
          }}
        >
          <strong style={{ display: "block", marginBottom: "0.5rem" }}>Response:</strong>
          <p style={{ lineHeight: "1.5", margin: 0 }}>{response}</p>
        </div>
      )}
    </div>
  );
}
